import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {RoutePaths} from "../../../util/constants";
import {ArrowBackIos} from "@mui/icons-material";
import * as React from "react";
import {Grid} from "@mui/material";
import {Helmet} from "react-helmet";

const NotFound = () => {
    const {t} = useTranslation()
    const navigate = useNavigate()

    const handleBackToHome = () => {
        navigate(RoutePaths.HOME)
    }

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex, nofollow"/>
            </Helmet>
            <Grid container height="100%" textAlign="center" alignItems="center" gap="0.5em" justifyContent="center"
                  flexDirection="column" flexGrow={1}>
                <Typography variant="h2" color="primary"
                            fontWeight="bold" lineHeight="0.8em">404</Typography>
                <Box>
                    <Typography variant="h5" color="primary"
                                fontWeight="bold">{t('page_not_found')}</Typography>
                    <Typography variant="body1" color="primary">{t('page_not_exist')}</Typography>
                    <Typography variant="body1" color="primary">{t('suggest_home')}</Typography>
                </Box>
                <Button variant="outlined"
                        onClick={handleBackToHome}
                        startIcon={<ArrowBackIos/>}>
                    {t('home')}
                </Button>
            </Grid>
        </>
    )
}

export default NotFound
